module.exports = __webpack_public_path__ + "img/about-7.29bdb173.png";